import { ChangeDetectorRef, Component, HostListener, isDevMode, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { PatientAppointmentSummaryComponent } from './modules/patient/patient-appointment-summary/patient-appointment-summary.component';
import { MessagingService } from './services/messaging.service';
import { Globals } from './globals';
import { AuthenticationService } from './modules/auth/services/authentication.service';
import { CurrentUser } from './modules/auth/model/CurrentUser';
import { formatDate } from '@angular/common';
import { NavigationStart, Router, RouterEvent } from '@angular/router';
import { PatientService } from './modules/patient/patient.service';
import { StaticDataService } from './services/static-data.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from './services/user.service';
import { UiService } from './services/ui.service';
import { SignalrService } from './services/socket/signalr.service';
import { LocalStorageService } from './services/local-storage.service';
import { DialogService } from './services/dialog.service';
import { ConfirmComponent } from './dialog/confirm-dialog/confirm.component';
import { MessagingConstants } from './models/MessagingConstants';
import { ToothService } from './services/tooth.service';
import { RoleGuard } from './modules/auth/helpers/role-guard';
import { filter, tap } from 'rxjs/operators';
import { HomeAccordionService } from "./main-interface/home/controls/home-accordion/home-accordion.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'TDOPro';
  currentUser: CurrentUser;

  patientSearchSubscription: any;
  showNotes: boolean = false;
  showNotifications: boolean = false;
  showLiveChat: boolean = false;
  showHeader: boolean = false;
  activityTimer: any;

  isPopupWindow: boolean = false;
  isLoading: boolean = false;
  messagingSubscription: any;

  private lastWindowsWidth: number = 0;
  private isWindowToSmallWarningActive = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private messagingService: MessagingService,
    private router: Router,
    private authService: AuthenticationService,
    public globals: Globals,
    private patientService: PatientService,
    private staticDataService: StaticDataService,
    public dialog: MatDialog,
    private dialogService: DialogService,
    public uiService: UiService,
    private localStorageService: LocalStorageService,
    private signalrService: SignalrService,
    private homeAccordionService: HomeAccordionService,
    private ngZone: NgZone
  ) {
    this.authService.currentUser.subscribe(x => {
      this.currentUser = x;
    });

    this.signalrService.messageUser.subscribe((message) => {
      switch (message.messageType) {
        case MessagingConstants.USER_ROLES_CHANGED:
          RoleGuard.checkAccess(this.router.url);
          break;
        case MessagingConstants.PATIENT_CHANGE_STARTLEDGER:
          // if (this.router.url !== '/reports' && this.router.url !== '/checkout') {
          if (this.router.url !== '/reports') {
            this.router.navigateByUrl('landing/ledger');
          }
          this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
            PatientID: message.message['PatientID'],
            PatientName: message.message['PatientName'],
            clearCurrentQuery: false,
            Process: MessagingConstants.DO_NOT_LOAD_CASE_VIEW
          });
          break;
      }
    });

    if (UserService.authToken) {
      if (!this.staticDataService.isReady) {
        this.staticDataService.refreshValues();
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.router.url === '/notes') {
      return;
    }
    if (this.lastWindowsWidth > window.innerWidth) {
      if (window.innerWidth < 1382 && !this.isWindowToSmallWarningActive) {
        this.isWindowToSmallWarningActive = true;
        this.dialogService.openConfirmDialog('This site is designed to be utilized in full screen.  Please increase window size.').subscribe((res) => {
          this.isWindowToSmallWarningActive = false;
        });
      }
    }

    if (window.innerWidth >= 1382 && this.isWindowToSmallWarningActive) {
      if (this.dialogService.confirmDialogRef) {
        this.isWindowToSmallWarningActive = false;
        this.dialogService.confirmDialogRef.close();
        this.dialogService.confirmDialogRef = null;
      }
    }

    this.lastWindowsWidth = window.innerWidth;
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    localStorage.removeItem('handleTDO12TokenFlag');
    this.messagingService.alertChildrenOnClosure();
    this.messagingService.alertOpenerOnClosure();
    this.uiService.closePopupWindows();
  }

  returnImageDimensionsFromURL(url: string): number[] {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url;
    const dimensions: number[] = [img.height, img.width];
    return dimensions;
  }

  ngOnInit() {
    this.router.events.pipe(
      filter((event: RouterEvent) => event instanceof NavigationStart),
      tap(() => this.dialog.closeAll())
    ).subscribe();

    // this.tokenTesting();

    this.router.events.subscribe((data) => {
      if (data instanceof NavigationStart) {
        if (data.url.includes('referralPortal')) {
          this.isPopupWindow = true;
        }
        else if (data.url === '/landing') {
          this.router.navigateByUrl('landing/case-view');
        }
        else if (data.url === '/patientportal/appointment/print') {
          this.showHeader = false;
        }
        else if (data.url.startsWith('/patientLogin')) {
          this.showHeader = false;
        }
        else if (data.url.includes('/patientportal')) {
          this.showHeader = true;
        }
        else if (data.url.startsWith('/payment-receipt')) {
          this.showHeader = false;
        }
        else
          this.showHeader = true;
      }
    });
    // if (this.authService.isLoggedIn()) {
    this.globals.load();
    if (this.localStorageService.currentUserData) {
      this.signalrService.connect();
    }


    this.messagingService.init();
    this.messagingSubscription = this.messagingService.componentMessageCall
      .subscribe(response => {
        const event = response.event;
        const eventData = response.data;

        if (event === 'Window-is-Popup') {
          this.isPopupWindow = true;
        }

        if (event === 'Popup-has-opened') {
          // if this module handles a pop-up - do something
        }

        if (event === 'Toggle-Notification-Display') {
          if (eventData.hide) {
            this.showNotifications = false;
          } else {
            this.showNotifications = !this.showNotifications;
          }
        }

        if (event === 'ALERT_MESSAGES_COUNT') {
          if (!this.showLiveChat) {
            this.messagingService.sendComponentMessage('UPDATE_MESSAGES_COUNT', { count: eventData.count });
          }
        }

        if (event === 'Toggle-Live-Chat-Display') {
          if (eventData.hide) {
            this.showLiveChat = false;
          } else {
            this.showLiveChat = !this.showLiveChat;
          }

          if (this.showLiveChat) {
            this.messagingService.sendComponentMessage('UPDATE_MESSAGES_COUNT', { count: 0 });
          }
        }

        if (event === 'Toggle-Notes-Display') {
          this.showNotes = eventData.display;
        }
        if (event === MessagingConstants.PATIENT_CHANGE_STARTLEDGER) {
          // start ledger
          this.router.navigateByUrl('landing/ledger');
          // switch patient
          this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
            PatientID: eventData.PatientId,
            PatientName: eventData.dataContact.FirstName + ' ' + eventData.dataContact.MidName + ' ' + eventData.dataContact.LastName,
            clearCurrentQuery: false,
            Process: MessagingConstants.DO_NOT_LOAD_CASE_VIEW
          });
        }
        if (event === MessagingConstants.VALID_VALUES_REFRESH) {
          // Refresh Valid Values
          this.staticDataService.refreshValues();
        }
        if (event === MessagingConstants.PATIENT_CHANGED) {
          console.log('event PATIENT_CHANGED');
          localStorage.setItem('isSelectedMTI', 'false');
          localStorage.setItem('isShowModuleSpecificNotes', 'true');
          this.uiService.handlePatientSwitchImagingWindow();
          this.globals.ThePatient = null;
          this.globals.currentPatientFullName = '';
          this.globals.currentPatientCaseId = null;
          this.globals.currentParentPatientCaseId = null;
          this.globals.save();

          if (eventData.PatientID) {
            eventData.PatientId = eventData.PatientID;
          }

          if (this.patientSearchSubscription) {
            this.patientSearchSubscription.unsubscribe();
            this.patientSearchSubscription = false;
          }

          if (eventData.PatientId !== 'null' && eventData.PatientId !== null) {

            this.patientSearchSubscription = this.patientService.getPatient(eventData.PatientId)
              .subscribe(patientResponse => {
                this.patientSearchSubscription = false;
                const res = patientResponse;

                if (res?.ThePatient) {
                  this.globals.ThePatient = res.ThePatient;

                  this.globals.currentPatientId = res.ThePatient.PatientId;
                  if (res.ThePatient.dataContact) {
                    const firstName = res.ThePatient.dataContact.FirstName || '';
                    const midName = res.ThePatient.dataContact.MidName || '';
                    const lastName = res.ThePatient.dataContact.LastName || '';
                    this.globals.currentPatientFullName = `${firstName} ${midName} ${lastName}`;
                    if (eventData.Process === MessagingConstants.DO_NOT_LOAD_CASE_VIEW) { // Load Patient without redirecting to  case view
                      this.messagingService.recursiveBroadCastMessage(MessagingConstants.PATIENT_LOADED, {
                        PatientID: this.globals.currentPatientId,
                        Process: MessagingConstants.DO_NOT_LOAD_CASE_VIEW,
                      });
                    }
                    else {
                      this.messagingService.recursiveBroadCastMessage(MessagingConstants.PATIENT_LOADED, this.globals.currentPatientId);
                    }
                  }
                }
                if (eventData.Process) {
                  switch (eventData.Process) {
                    case MessagingConstants.CHECKOUT_PATIENT_START:  // Check out
                      this.globals.currentPatientCaseId = eventData.PatientCaseId;
                      this.globals.currentParentPatientCaseId = eventData.ParentPatientCaseId;
                      this.messagingService.broadCastMessage(MessagingConstants.CHECKOUT_PATIENT_START, {});
                      break;
                    case MessagingConstants.RELOAD_SCHEDULE_APPOINTMENTS:  // Reload schedule appointments
                      this.homeAccordionService.loadScheduleAppointments();
                      break;
                    default:

                    // code block
                  }
                }
                this.globals.save();
              }, err => {
                this.patientSearchSubscription = false;
              });
          }
          this.uiService.handlePatientSwitchImagingWindow();
        }
      });
      console.log('AppComponent -> ngOnInit -> this.showHeader', this.showHeader);
  }

  deleteKey(jsonObj, path): any {
    const obj = JSON.parse(JSON.stringify(jsonObj));
    const keys = path.split('.');

    keys.reduce((acc, key, index) => {
      if (key === '') {
        return acc;
      }

      if (index === keys.length - 1) {

        delete acc[key];
        return true;

      }
      return acc[key];
    }, obj);

    return obj;
  }

  initActivityMonitor() {
    if (this.router.url.includes('/referralPortal') || this.router.url.includes('/login')){
      return;
    }

    const token = localStorage.getItem('TDOauthToken');
    // 60 minute inactivity check.
    if (token && typeof token !== undefined) {
      this.activityTimer = setTimeout(_ => {
        this.authService.logout();
        this.messagingService.alertChildrenOnClosure();
        this.uiService.closePopupWindows();
        if (this.router.url.includes('/scheduler') || this.router.url.includes('/configuration') || this.router.url.includes('/forms/builder')
          || this.router.url.includes('/studio') || this.router.url.includes('/reports') || this.router.url.includes('/appointment/print'))
          window.close();
        else if (this.router.url.includes('/patientportal'))
          this.router.navigateByUrl(`/patientLogin`);
        else if (this.router.url.includes('/referrerportal'))
          this.router.navigateByUrl(`/referrerLogin`);
        else if (!this.router.url.includes('/patientLogin') && !this.router.url.includes('/referrerLogin') && !this.router.url.includes('/login')){
          this.router.navigate(['/login']);
        }
      }, 1000 * 60 * 60);
    }
    else { //No token found
      this.messagingService.alertChildrenOnClosure();
      this.uiService.closePopupWindows();
      if (this.router.url.includes('/scheduler') || this.router.url.includes('/configuration') || this.router.url.includes('/forms/builder') || this.router.url.includes('/studio') || this.router.url.includes('/reports'))
        window.close();
      else if (this.router.url.includes('/patientportal'))
        this.router.navigateByUrl(`/patientLogin`);
      else if (this.router.url.includes('/referrerportal'))
        this.router.navigateByUrl(`/referrerLogin`);
      else if (!this.router.url.includes('/patientLogin') && !this.router.url.includes('/referrerLogin') && this.router.url !== '/login'){
        console.log('initActivityMonitor navigate to login -> this.router.url', this.router.url);
        this.ngZone.run(() => { this.router.navigate(['/login']); });
      }
    }
  }

  @HostListener('window:mousemove') clearActivityTimer() {
    if (this.activityTimer) {
      clearTimeout(this.activityTimer);
    }
    this.initActivityMonitor();
  }

  ngOnDestroy() {
    this.messagingSubscription.unsubscribe();
  }
}
